import { __assign } from '../../external/tslib/tslib.es6.mjs.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import clsx from 'clsx';
import { PlusIcon } from '../../icons/PlusIcon.js';
import { MinusIcon } from '../../icons/MinusIcon.js';
import styles from './Counter.module.scss.js';

var Counter = function (_a) {
    var value = _a.value, setValue = _a.setValue, className = _a.className, style = _a.style;
    return (jsxs("div", __assign({ className: clsx(styles.counter, className), style: style }, { children: [jsx("button", __assign({ disabled: value === 0, className: styles.btn, onClick: function () { return setValue(value - 1); } }, { children: jsx(MinusIcon, {}) })), jsx("div", __assign({ className: styles.valueWrapper }, { children: value })), jsx("button", __assign({ className: styles.btn, onClick: function () { return setValue(value + 1); } }, { children: jsx(PlusIcon, {}) }))] })));
};

export { Counter };
